import { Plus } from "lucide-react";
import { LucideProps } from "lucide-react";

interface PlusIconProps extends LucideProps {
  className?: string;
}

export default function PlusIcon({ className = "", size = 24, ...props }: PlusIconProps) {
  return <Plus className={className} size={size} {...props} />;
}
